import { useEffect, useState } from 'react';

import { DeviceStatus } from 'chaika-enums';

import { OptionType, Select, SelectProps } from '@components/Select';
import { translate } from '@chaika/i18n/helper';
import { isDefined } from '@utils/isDefined';
import { makeOptionType } from '@utils/makeOptionTypes';
import { deviceService } from '@organization/service/device/deviceService';
import { store } from '@store';

export interface Props extends Omit<SelectProps, 'selectedValue' | 'options'> {
    dataTest?: string;
    deviceId?: string;
}

export function DeviceSelect({ dataTest = 'deviceSelect', title, deviceId, ...props }: Props) {
    const { deviceList } = store;
    const [options, setOptions] = useState<OptionType[]>([]);

    useEffect(() => {
        (async () => {
            await Promise.all([deviceService.load()]);
            setOptions(makeOptions());
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deviceId]);

    function makeOptions(): OptionType[] {
        const selectedDevice = isDefined(deviceId) ? deviceList.get(deviceId) : undefined;
        const activeDevices = deviceList.activeDevices;

        return makeOptionType(
            selectedDevice?.status === DeviceStatus.Archived ? [selectedDevice, ...activeDevices] : activeDevices,
        );
    }
    return (
        <Select
            dataTest={dataTest}
            title={title ?? translate('device')}
            selectedValue={deviceId}
            options={options}
            {...props}
        />
    );
}
